import React, {Component} from 'react';
import {Row, Col, Form, FormGroup, ControlLabel, FormControl} from "react-bootstrap";
import {TopInputDate} from "../../../../../componentsTopsa/inputs/TopInputs";
import {TopButtonCancel, TopButtonSave} from "../../../../../componentsTopsa/buttons/TopButtons";
import DateFormat from "../../../../../utilities/DateAndTimeFormat";
import moment from "moment";
import Validator from "../../../../../utilities/Validator";
import ValidatorMessages from "../../../../../shared/validatorMessages/ValidatorMessages";
import {TopSelect} from "../../../../../componentsTopsa/selects/TopSelects";

export default class KierowcyForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            idKiSt:null,
            data_waznosci_prawa_jazdy: null,
            data_waznosci_badan_lek: null,
            data_waznosci_badan_psych: null,
            data_waznosci_bhp: null,
            dataZatrudnienia_od: null,
            dataZatrudnienia_do: null,
            dataUrodzenia: null,
            imie: '',
            nazwisko: '',
            miejsce_urodzenia: '',
            pesel: '',
            telefon: '',
            email: '',
            miejscowosc: '',
            kodPocztowy: '',
            ulica: '',
            nrDomu: '',
            nrMieszkania: '',
            nr_prawa_jazdy: '',
            id_licencji_dr: '',
            nrUprawnien: '',
            nrDokumentow: '',
            stanowisko: '',
            uwagi: '',
            validateMessages:[],
            status:null,
            statusy:[{value:1,label:'aktywny'},{value:0,label:'nieaktywny'}],
            podstawa:null,
            nrTelEbus:'',
        };
        this.onClickZapisz = this.onClickZapisz.bind(this)
        this.onChangeWartosc = this.onChangeWartosc.bind(this)
        this.onChangeDataUrodzenia = this.onChangeDataUrodzenia.bind(this)
        this.onChangeDataWaznosciPrawaJazdy = this.onChangeDataWaznosciPrawaJazdy.bind(this)
        this.onChangeBadaniaLekarskie = this.onChangeBadaniaLekarskie.bind(this)
        this.onChangeBadaniaPsychologiczne = this.onChangeBadaniaPsychologiczne.bind(this)
        this.onChangeBHP = this.onChangeBHP.bind(this)
        this.onChangeZatrudnionyOd = this.onChangeZatrudnionyOd.bind(this)
        this.onChangeZatrudnionyDo = this.onChangeZatrudnionyDo.bind(this)
        this.onChangeStatus = this.onChangeStatus.bind(this)
        this.onChangePodstawa = this.onChangePodstawa.bind(this)
    }

    componentDidMount() {
        if (Boolean(this.props.kierowca)) {
            this.setState({
                idKiSt:this.props.kierowca.idKiSt,
                data_waznosci_prawa_jazdy: Boolean(this.props.kierowca.dataWaznPrawJazd)?moment(this.props.kierowca.dataWaznPrawJazd):null,
                data_waznosci_badan_lek: Boolean(this.props.kierowca.dataBadLek)?moment(this.props.kierowca.dataBadLek):null,
                data_waznosci_badan_psych: Boolean(this.props.kierowca.dataBadPsych)?moment(this.props.kierowca.dataBadPsych):null,
                data_waznosci_bhp: Boolean(this.props.kierowca.dataBadBhp)?moment(this.props.kierowca.dataBadBhp):null,
                dataZatrudnienia_od: Boolean(this.props.kierowca.dataZat)?moment(this.props.kierowca.dataZat):null,
                dataZatrudnienia_do: Boolean(this.props.kierowca.dataZwoln)?moment(this.props.kierowca.dataZwoln):null,
                dataUrodzenia: Boolean(this.props.kierowca.dataUr)?moment(this.props.kierowca.dataUr):null,
                imie: Boolean(this.props.kierowca.imie)? this.props.kierowca.imie : '',
                nazwisko: Boolean(this.props.kierowca.nazwisko)?this.props.kierowca.nazwisko : '',
                miejsce_urodzenia: Boolean(this.props.kierowca.miejUr)?this.props.kierowca.miejUr : '',
                pesel: Boolean(this.props.kierowca.pesel)?this.props.kierowca.pesel : '',
                telefon: Boolean(this.props.kierowca.nrTel)?this.props.kierowca.nrTel : '',
                nrTelEbus: Boolean(this.props.kierowca.nrTelEbus)?this.props.kierowca.nrTelEbus : '',
                email: Boolean(this.props.kierowca.email)?this.props.kierowca.email : '',
                miejscowosc: Boolean(this.props.kierowca.miejscowosc)?this.props.kierowca.miejscowosc : '',
                kodPocztowy: Boolean(this.props.kierowca.kodPoczt)?this.props.kierowca.kodPoczt : '',
                ulica: Boolean(this.props.kierowca.ulica)?this.props.kierowca.ulica : '',
                nrDomu: Boolean(this.props.kierowca.nrDomu)?this.props.kierowca.nrDomu : '',
                nrMieszkania: Boolean(this.props.kierowca.nrMieszk)?this.props.kierowca.nrMieszk : '',
                nr_prawa_jazdy: Boolean(this.props.kierowca.nrPrawJaz)?this.props.kierowca.nrPrawJaz : '',
                id_licencji_dr: Boolean(this.props.kierowca.idDrLic)?this.props.kierowca.idDrLic : '',
                nrUprawnien: Boolean(this.props.kierowca.nrUprawn)?this.props.kierowca.nrUprawn : '',
                nrDokumentow: Boolean(this.props.kierowca.nrDok)?this.props.kierowca.nrDok : '',
                stanowisko: Boolean(this.props.kierowca.stanowisko)?this.props.kierowca.stanowisko : '',
                uwagi: Boolean(this.props.kierowca.uwagi)?this.props.kierowca.uwagi : '',
                podstawa: this.props.kierowca.podstawa,
                status: (Boolean(this.props.kierowca.status) || this.props.kierowca.status===0)? this.state.statusy.find(s=>s.value==this.props.kierowca.status):null
            })


            document.getElementById('inputPodstawa').value= this.props.kierowca.podstawa;
        }else{
            this.setState({status:this.state.statusy[0]})
        }
    }

    componentWillReceiveProps(nextprops){
        if(nextprops.kierowca){
            this.setState({
                idKiSt:nextprops.kierowca.idKiSt,
                data_waznosci_prawa_jazdy: Boolean(nextprops.kierowca.dataWaznPrawJazd)?moment(nextprops.kierowca.dataWaznPrawJazd):null,
                data_waznosci_badan_lek: Boolean(nextprops.kierowca.dataBadLek)?moment(nextprops.kierowca.dataBadLek):null,
                data_waznosci_badan_psych: Boolean(nextprops.kierowca.dataBadPsych)?moment(nextprops.kierowca.dataBadPsych):null,
                data_waznosci_bhp: Boolean(nextprops.kierowca.dataBadBhp)?moment(nextprops.kierowca.dataBadBhp):null,
                dataZatrudnienia_od: Boolean(nextprops.kierowca.dataZat)?moment(nextprops.kierowca.dataZat):null,
                dataZatrudnienia_do: Boolean(nextprops.kierowca.dataZwoln)?moment(nextprops.kierowca.dataZwoln):null,
                dataUrodzenia: Boolean(nextprops.kierowca.dataUr)?moment(nextprops.kierowca.dataUr):null,
                imie: Boolean(nextprops.kierowca.imie)? nextprops.kierowca.imie : '',
                nazwisko: Boolean(nextprops.kierowca.nazwisko)?nextprops.kierowca.nazwisko : '',
                miejsce_urodzenia: Boolean(nextprops.kierowca.miejUr)?nextprops.kierowca.miejUr : '',
                pesel: Boolean(nextprops.kierowca.pesel)?nextprops.kierowca.pesel : '',
                telefon: Boolean(nextprops.kierowca.nrTel)?nextprops.kierowca.nrTel : '',
                nrTelEbus: Boolean(nextprops.kierowca.nrTelEbus)?nextprops.kierowca.nrTelEbus : '',
                email: Boolean(nextprops.kierowca.email)?nextprops.kierowca.email : '',
                miejscowosc: Boolean(nextprops.kierowca.miejscowosc)?nextprops.kierowca.miejscowosc : '',
                kodPocztowy: Boolean(nextprops.kierowca.kodPoczt)?nextprops.kierowca.kodPoczt : '',
                ulica: Boolean(nextprops.kierowca.ulica)?nextprops.kierowca.ulica : '',
                nrDomu: Boolean(nextprops.kierowca.nrDomu)?nextprops.kierowca.nrDomu : '',
                nrMieszkania: Boolean(nextprops.kierowca.nrMieszk)?nextprops.kierowca.nrMieszk : '',
                nr_prawa_jazdy: Boolean(nextprops.kierowca.nrPrawJaz)?nextprops.kierowca.nrPrawJaz : '',
                id_licencji_dr: Boolean(nextprops.kierowca.idDrLic)?nextprops.kierowca.idDrLic : '',
                nrUprawnien: Boolean(nextprops.kierowca.nrUprawn)?nextprops.kierowca.nrUprawn : '',
                nrDokumentow: Boolean(nextprops.kierowca.nrDok)?nextprops.kierowca.nrDok : '',
                stanowisko: Boolean(nextprops.kierowca.stanowisko)?nextprops.kierowca.stanowisko : '',
                uwagi: Boolean(nextprops.kierowca.uwagi)?nextprops.kierowca.uwagi : '',
                podstawa: nextprops.kierowca.podstawa,
                status: (Boolean(nextprops.kierowca.status) || nextprops.kierowca.status===0)? this.state.statusy.find(s=>s.value==nextprops.kierowca.status):null
            })
            document.getElementById('inputImie').value= nextprops.kierowca.imie;
            document.getElementById('inputNazwisko').value= nextprops.kierowca.nazwisko;
            document.getElementById('inputMiejsceUrodzenia').value= nextprops.kierowca.miejUr;
            document.getElementById('PeselInput').value= nextprops.kierowca.pesel;
            document.getElementById('inputTelefon').value= nextprops.kierowca.nrTel;
            document.getElementById('inputTelefonEbus').value= nextprops.kierowca.nrTelEbus;
            document.getElementById('inputEmail').value= nextprops.kierowca.email;
            document.getElementById('inputMiejscowosc').value= nextprops.kierowca.miejscowosc;
            document.getElementById('inputKodPocztowy').value= nextprops.kierowca.kodPoczt;
            document.getElementById('inputUlica').value= nextprops.kierowca.ulica;
            document.getElementById('inputNrDomu').value= nextprops.kierowca.nrDomu;
            document.getElementById('inputNrMieszkania').value= nextprops.kierowca.nrMieszk;
            document.getElementById('inputPrawoJazdy').value= nextprops.kierowca.nrPrawJaz;
            document.getElementById('inputLicencja').value= nextprops.kierowca.idDrLic;
            document.getElementById('inputUprawnienia').value= nextprops.kierowca.nrUprawn;
            document.getElementById('inputDokumenty').value= nextprops.kierowca.nrDok;
            document.getElementById('inputStanowisko').value= nextprops.kierowca.stanowisko;
            document.getElementById('inputUwagi').value= nextprops.kierowca.uwagi;
            document.getElementById('inputPodstawa').value= nextprops.kierowca.podstawa;
        }
    }

    onChangePodstawa(e){
        this.setState({
            podstawa: e.target.value
        })
    }

    onChangeWartosc(wartosc, e) {
        this.state[wartosc] = e.target.value
    }
    onChangeStatus(e) {
        this.setState({status:e})
    }

    onChangeWartoscAndValidate(wartosc,e,max,elem){
        if(Validator.validateLenghtWithClearing(e.target.value,max,elem,this.state[wartosc])){
            this.setState({[wartosc]:e.target.value})
        }
    }

    onChangeDataUrodzenia(e) {
        this.setState({dataUrodzenia: e})

        if (e !== null) {

            let data = e._d

            let year = data.getFullYear().toString().substr(2, 4);
            let month = (data.getMonth() + 1).toString();
            let day = data.getDate().toString();

            if (data.getMonth() + 1 < 10) {
                month = '0' + (data.getMonth() + 1).toString()
            }

            if (data.getDate() < 10) {
                day = '0' + data.getDate().toString()
            }

            let p = year + month + day;

            this.setState({pesel: p})
            document.getElementById('PeselInput').value = p
        }
    }

    onChangeDataWaznosciPrawaJazdy(e) {
        this.setState({data_waznosci_prawa_jazdy: e})
    }

    onChangeBadaniaLekarskie(e) {
        this.setState({data_waznosci_badan_lek: e})
    }

    onChangeBadaniaPsychologiczne(e) {
        this.setState({data_waznosci_badan_psych: e})
    }

    onChangeBHP(e) {
        this.setState({data_waznosci_bhp: e})
    }

    onChangeZatrudnionyOd(e) {
        this.setState({dataZatrudnienia_od: e})
    }

    onChangeZatrudnionyDo(e) {
        this.setState({dataZatrudnienia_do: e})
    }

    dodajDoValidatorMessages(msg) {
        let arr = this.state.validateMessages;
        arr.push(msg)
        this.setState({validateMessages: arr})
    }
    
    onClickZapisz() {

        let poprawne = true; this.state.validateMessages = [];

        if(!Boolean(this.state.imie)){
            poprawne=false;
            this.dodajDoValidatorMessages('Nie uzupełniono pola imię')
        }

        if(!(Boolean(this.state.nazwisko))){
            poprawne=false;
            this.dodajDoValidatorMessages('Nie uzupełniono pola nazwisko')
        }
        if(!(Boolean(this.state.status))){
            poprawne=false;
            this.dodajDoValidatorMessages('Nie uzupełniono pola status')
        }

        if(Boolean(this.state.id_licencji_dr)){
            if(!Validator.validateInt(this.state.id_licencji_dr,false)){
                poprawne=false;
                this.dodajDoValidatorMessages('ID licencji musi być liczbą całkowitą')
            }
        }

        if(Boolean(this.state.podstawa)){
            if(Validator.validateIntOrDouble(this.state.podstawa) || this.state.podstawa == 0){
               // jest ok
            }
            else{
                poprawne=false;
                this.dodajDoValidatorMessages('Podstawa musi być liczbą całkowitą lub zmiennoprzecinkową nieujemną')
            }
        }

        if (poprawne) {


            this.setState({validateMessages:[]})
            let data = {
                "idKiSt":this.state.idKiSt,
                "imie": this.state.imie,
                "nazwisko": this.state.nazwisko,
                "kodPoczt": this.state.kodPocztowy,
                "miejscowosc": this.state.miejscowosc,
                "ulica": this.state.ulica,
                "nrDomu": this.state.nrDomu,
                "nrMieszk": this.state.nrMieszkania,
                "nrDok": this.state.nrDokumentow,
                "pesel": this.state.pesel,
                "nrTel": this.state.telefon,
                "nrTelEbus": this.state.nrTelEbus,
                "nrPrawJaz": this.state.nr_prawa_jazdy,
                "nrUprawn": this.state.nrUprawnien,
                "dataBadLek": DateFormat.formatYYYYMMDD(this.state.data_waznosci_badan_lek),
                "email": this.state.email,
                "dataWaznPrawJazd": DateFormat.formatYYYYMMDD(this.state.data_waznosci_prawa_jazdy),
                "idDrLic": this.state.id_licencji_dr,
                "uwagi": this.state.uwagi,
                "dataBadBhp": DateFormat.formatYYYYMMDD(this.state.data_waznosci_bhp),
                "dataZat": DateFormat.formatYYYYMMDD(this.state.dataZatrudnienia_od),
                "dataZwoln": DateFormat.formatYYYYMMDD(this.state.dataZatrudnienia_do),
                "dataBadPsych": DateFormat.formatYYYYMMDD(this.state.data_waznosci_badan_psych),
                "stanowisko": this.state.stanowisko,
                "dataUr": DateFormat.formatYYYYMMDD(this.state.dataUrodzenia),
                "miejUr": this.state.miejsce_urodzenia,
                "status": this.state.status.value,
                "podstawa": this.state.podstawa
            }


            if (Boolean(this.props.kierowca)) {
                this.props.handleClickZapisz(data, true)
            }
            else {
                this.props.handleClickZapisz(data, false)
            }
        }
    }

    render() {

        return (

            <div>
                <fieldset>
                    <div className={'fieldset-label'}>{Boolean(this.props.kierowca) ? 'Edycja kierowcy' : 'Nowy kierowca'}</div>
                <Form horizontal={true} className={'horizontal-form'}>
                    <Row>
                        <Col xs={12} lg={6}>
                            <FormGroup>
                                <h6>Dane osobowe</h6>
                                <Col xs={12}>
                                    <ControlLabel>
                                        Imię <span className={'req'}>*</span> <span style={{fontSize:'12px', color:'grey',fontStyle:'italic', fontWeight:'normal'}}>{this.state.imie.length}/20 znaków</span>
                                    </ControlLabel>
                                    <FormControl onChange={(e) => this.onChangeWartoscAndValidate("imie", e,20,'inputImie')}
                                                 defaultValue={Boolean(this.props.kierowca) ? this.props.kierowca.imie : ''} id={'inputImie'}/>
                                </Col>
                                <Col xs={12}>
                                    <ControlLabel>
                                        Nazwisko <span className={'req'}>*</span>   <span style={{fontSize:'12px', color:'grey',fontStyle:'italic', fontWeight:'normal'}}>{this.state.nazwisko.length}/30 znaków</span>
                                    </ControlLabel>
                                    <FormControl onChange={(e) => this.onChangeWartoscAndValidate("nazwisko", e,30,'inputNazwisko')}
                                                 defaultValue={Boolean(this.props.kierowca) ? this.props.kierowca.nazwisko : ''} id={'inputNazwisko'}/>
                                </Col>
                                <Col xs={12}>
                                    <ControlLabel>
                                        Miejsce urodzenia   <span style={{fontSize:'12px', color:'grey',fontStyle:'italic', fontWeight:'normal'}}>{this.state.miejsce_urodzenia.length}/30 znaków</span>
                                    </ControlLabel>
                                    <FormControl onChange={(e) => this.onChangeWartoscAndValidate("miejsce_urodzenia", e,30, 'inputMiejsceUrodzenia')}
                                                 defaultValue={Boolean(this.props.kierowca) ? this.props.kierowca.miejUr : ''} id={'inputMiejsceUrodzenia'}/>
                                </Col>
                                <Col xs={12}>
                                    <ControlLabel>
                                        Data urodzenia
                                    </ControlLabel>
                                    <TopInputDate onChange={this.onChangeDataUrodzenia} value={this.state.dataUrodzenia}/>
                                </Col>
                                <Col xs={12}>
                                    <ControlLabel>
                                        PESEL   <span style={{fontSize:'12px', color:'grey',fontStyle:'italic', fontWeight:'normal'}}>{this.state.pesel.length}/11 znaków</span>
                                    </ControlLabel>
                                    <FormControl onChange={(e) => this.onChangeWartoscAndValidate("pesel", e,11,'PeselInput')}
                                                 defaultValue={Boolean(this.props.kierowca) ? this.props.kierowca.pesel : ''} id={'PeselInput'}/>
                                </Col>
                            </FormGroup>
                            <FormGroup>
                                <h6>Dane teleadresowe</h6>
                                <Col xs={12}>
                                    <ControlLabel>
                                        Telefon prywatny <span style={{fontSize:'12px', color:'grey',fontStyle:'italic', fontWeight:'normal'}}>{this.state.telefon.length}/15 znaków</span>
                                    </ControlLabel>
                                    <FormControl type="number" onChange={(e) => this.onChangeWartoscAndValidate("telefon", e,15,'inputTelefon')}
                                                 defaultValue={Boolean(this.props.kierowca) ? this.props.kierowca.nrTel : ''} id={'inputTelefon'}/>
                                </Col>
                                <Col xs={12}>
                                    <ControlLabel>
                                        Email   <span style={{fontSize:'12px', color:'grey',fontStyle:'italic', fontWeight:'normal'}}>{this.state.email.length}/30 znaków</span>
                                    </ControlLabel>
                                    <FormControl onChange={(e) => this.onChangeWartoscAndValidate("email", e,30,'inputEmail')}
                                                 defaultValue={Boolean(this.props.kierowca) ? this.props.kierowca.email : ''} id={'inputEmail'}/>
                                </Col>
                                <Col xs={12}>
                                    <ControlLabel>
                                        Miejscowość   <span style={{fontSize:'12px', color:'grey',fontStyle:'italic', fontWeight:'normal'}}>{this.state.miejscowosc.length}/30 znaków</span>
                                    </ControlLabel>
                                    <FormControl onChange={(e) => this.onChangeWartoscAndValidate("miejscowosc", e,30,'inputMiejscowosc')}
                                                 defaultValue={Boolean(this.props.kierowca) ? this.props.kierowca.miejscowosc : ''} id={'inputMiejscowosc'}/>
                                </Col>
                                <Col xs={12}>
                                    <ControlLabel>
                                        Kod pocztowy   <span style={{fontSize:'12px', color:'grey',fontStyle:'italic', fontWeight:'normal'}}>{this.state.kodPocztowy.length}/10 znaków</span>
                                    </ControlLabel>
                                    <FormControl onChange={(e) => this.onChangeWartoscAndValidate("kodPocztowy", e,10,'inputKodPocztowy')}
                                                 defaultValue={Boolean(this.props.kierowca) ? this.props.kierowca.kodPoczt : ''} id={'inputKodPocztowy'}/>
                                </Col>
                                <Col xs={12}>
                                    <ControlLabel>
                                        Ulica   <span style={{fontSize:'12px', color:'grey',fontStyle:'italic', fontWeight:'normal'}}>{this.state.ulica.length}/60 znaków</span>
                                    </ControlLabel>
                                    <FormControl onChange={(e) => this.onChangeWartoscAndValidate("ulica", e,60,'inputUlica')}
                                                 defaultValue={Boolean(this.props.kierowca) ? this.props.kierowca.ulica : ''} id={'inputUlica'}/>
                                </Col>
                                <Col xs={12}>
                                    <ControlLabel>
                                        Nr domu   <span style={{fontSize:'12px', color:'grey',fontStyle:'italic', fontWeight:'normal'}}>{this.state.nrDomu.length}/10 znaków</span>
                                    </ControlLabel>
                                    <FormControl onChange={(e) => this.onChangeWartoscAndValidate("nrDomu", e,10,'inputNrDomu')}
                                                 defaultValue={Boolean(this.props.kierowca) ? this.props.kierowca.nrDomu : ''} id={'inputNrDomu'}/>
                                </Col>
                                <Col xs={12}>
                                    <ControlLabel>
                                        Nr miesz   <span style={{fontSize:'12px', color:'grey',fontStyle:'italic', fontWeight:'normal'}}>{this.state.nrMieszkania.length}/10 znaków</span>
                                    </ControlLabel>
                                    <FormControl onChange={(e) => this.onChangeWartoscAndValidate("nrMieszkania", e,10,'inputNrMieszkania')}
                                                 defaultValue={Boolean(this.props.kierowca) ? this.props.kierowca.nrMieszk : ''} id={'inputNrMieszkania'}/>
                                </Col>
                            </FormGroup>
                            <FormGroup>
                                <h6>Telefon służbowy</h6>
                                <Col xs={12}>
                                    <ControlLabel>
                                        Telefon służbowy  <span style={{fontSize:'12px', color:'grey',fontStyle:'italic', fontWeight:'normal'}}>{this.state.nrTelEbus.length}/15 znaków</span>
                                    </ControlLabel>
                                    <FormControl type="number" onChange={(e) => this.onChangeWartoscAndValidate("nrTelEbus", e,15,'inputTelefonEbus')}
                                                 defaultValue={Boolean(this.props.kierowca) ? this.props.kierowca.nrTelEbus : ''} id={'inputTelefonEbus'}/>
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col xs={12} lg={6}>
                            <FormGroup>
                                <h6>Dane dotyczące zatrudnienia</h6>
                                <Col xs={12}>
                                    <ControlLabel>
                                        Status
                                    </ControlLabel>
                                    <TopSelect onChange={this.onChangeStatus} value={this.state.status} options={this.state.statusy} clearable={false}/>
                                </Col>
                                <Col xs={12}>
                                    <ControlLabel>
                                        Stanowisko   <span style={{fontSize:'12px', color:'grey',fontStyle:'italic', fontWeight:'normal'}}>{this.state.stanowisko.length}/30 znaków</span>
                                    </ControlLabel>
                                    <FormControl onChange={(e) => this.onChangeWartoscAndValidate("stanowisko", e,30,'inputStanowisko')}
                                                 defaultValue={Boolean(this.props.kierowca) ? this.props.kierowca.stanowisko : ''} id={'inputStanowisko'}/>
                                </Col>
                                <Col xs={12}>
                                    <ControlLabel>
                                        Zatrudniony od
                                    </ControlLabel>
                                    <TopInputDate onChange={this.onChangeZatrudnionyOd} value={this.state.dataZatrudnienia_od}/>
                                </Col>
                                <Col xs={12}>
                                    <ControlLabel>
                                        Zatrudniony do
                                    </ControlLabel>
                                    <TopInputDate onChange={this.onChangeZatrudnionyDo} value={this.state.dataZatrudnienia_do}/>
                                </Col>
                                <Col xs={12}>
                                    <ControlLabel>
                                        Podstawowa stawka
                                    </ControlLabel>
                                    <FormControl type={'number'} onChange={this.onChangePodstawa} id={'inputPodstawa'}/>
                                </Col>
                            </FormGroup>
                            <FormGroup>
                                <h6>Dokumenty</h6>
                                <Col xs={12}>
                                    <ControlLabel>
                                        Nr prawa jazdy   <span style={{fontSize:'12px', color:'grey',fontStyle:'italic', fontWeight:'normal'}}>{this.state.nr_prawa_jazdy.length}/15 znaków</span>
                                    </ControlLabel>
                                    <FormControl onChange={(e) => this.onChangeWartoscAndValidate("nr_prawa_jazdy", e,15,'inputPrawoJazdy')}
                                                 defaultValue={Boolean(this.props.kierowca) ? this.props.kierowca.nrPrawJaz : ''} id={'inputPrawoJazdy'}/>
                                </Col>
                                <Col xs={12}>
                                    <ControlLabel>
                                        Data ważności prawa jazdy
                                    </ControlLabel>
                                    <TopInputDate onChange={this.onChangeDataWaznosciPrawaJazdy} value={this.state.data_waznosci_prawa_jazdy}/>
                                </Col>
                                <Col xs={12}>
                                    <ControlLabel>
                                        ID licencji dr
                                    </ControlLabel>
                                    <FormControl onChange={(e) => this.onChangeWartosc("id_licencji_dr", e)}
                                                 defaultValue={Boolean(this.props.kierowca) ? this.props.kierowca.idDrLic : ''} id={'inputLicencja'}/>
                                </Col>
                                <Col xs={12}>
                                    <ControlLabel>
                                        Nr uprawnień   <span style={{fontSize:'12px', color:'grey',fontStyle:'italic', fontWeight:'normal'}}>{this.state.nrUprawnien.length}/15 znaków</span>
                                    </ControlLabel>
                                    <FormControl onChange={(e) => this.onChangeWartoscAndValidate("nrUprawnien", e,15,'inputUprawnienia')}
                                                 defaultValue={Boolean(this.props.kierowca) ? this.props.kierowca.nrUprawn : ''} id={'inputUprawnienia'}/>
                                </Col>
                                <Col xs={12}>
                                    <ControlLabel>
                                        Nr dokumentów   <span style={{fontSize:'12px', color:'grey',fontStyle:'italic', fontWeight:'normal'}}>{this.state.nrDokumentow.length}/15 znaków</span>
                                    </ControlLabel>
                                    <FormControl onChange={(e) => this.onChangeWartoscAndValidate("nrDokumentow", e,15,'inputDokumenty')}
                                                 defaultValue={Boolean(this.props.kierowca) ? this.props.kierowca.nrDok : ''} id={'inputDokumenty'}/>
                                </Col>
                            </FormGroup>
                            <FormGroup>
                                <h6>Badania</h6>
                                <Col xs={12}>
                                    <ControlLabel>
                                        B. lekarskie
                                    </ControlLabel>
                                    <TopInputDate onChange={this.onChangeBadaniaLekarskie} value={this.state.data_waznosci_badan_lek}/>
                                </Col>
                                <Col xs={12}>
                                    <ControlLabel>
                                        B. psychologiczne
                                    </ControlLabel>
                                    <TopInputDate onChange={this.onChangeBadaniaPsychologiczne} value={this.state.data_waznosci_badan_psych}/>
                                </Col>
                                <Col xs={12}>
                                    <ControlLabel>
                                        B. BHP
                                    </ControlLabel>
                                    <TopInputDate onChange={this.onChangeBHP} value={this.state.data_waznosci_bhp}/>
                                </Col>
                            </FormGroup>
                            <FormGroup>
                                <h6>Inne</h6>
                                <Col xs={12}>
                                    <ControlLabel>
                                        Uwagi   <span style={{fontSize:'12px', color:'grey',fontStyle:'italic', fontWeight:'normal'}}>{this.state.uwagi.length}/30 znaków</span>
                                    </ControlLabel>
                                    <FormControl onChange={(e) => this.onChangeWartoscAndValidate("uwagi", e,30,'inputUwagi')}
                                                 defaultValue={Boolean(this.props.kierowca) ? this.props.kierowca.uwagi : ''} id={'inputUwagi'}/>
                                </Col>
                                <Col xs={12}>
                                    <div className={'add-label-margin'}></div>
                                    <TopButtonCancel onClick={() => {
                                        this.props.handleClickAnuluj()
                                    }} text={'Anuluj'}/>
                                    <TopButtonSave onClick={this.onClickZapisz} text={'Zapisz'}/>
                                </Col>
                            </FormGroup>
                            <FormGroup>
                                <ValidatorMessages messages={this.state.validateMessages}/>
                            </FormGroup>
                        </Col>
                    </Row>
                </Form>
                </fieldset>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/zasobyConfig/kierowcy/components/KierowcyForm.js